import React from "react";
import cn from "classnames";
import styles from "./TypeInput.module.scss";
import { HomePageError } from "@/components/common/HomePageError";
interface TypeInputProps {
  label?: any;
  placeholder?: string;
  name: string;
  value?: string;
  defaultValue?: string;
  errors?: string[] | null;
  success?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  type?: "text" | "radio" | "checkbox";
  isRequired?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  autoFocus?: boolean;
  customError?: boolean;
  checked?: boolean;
  cls?: string;
  noMargin?: boolean;
}
const TypeInput: React.FC<TypeInputProps> = ({
  label,
  placeholder,
  name,
  value,
  defaultValue,
  errors,
  customError = false,
  success,
  onChange,
  onBlur,
  onFocus,
  type = "text",
  isRequired = false,
  inputRef,
  autoFocus,
  checked,
  cls,
  noMargin
}) => {
  const isRadioOrCheckbox = type === "radio" || type === "checkbox";
  return <div className={cn(styles.inputContainer, {
    [styles.radioOrCheckboxContainer]: isRadioOrCheckbox
  })} data-sentry-component="TypeInput" data-sentry-source-file="TypeInput.tsx">
            {isRadioOrCheckbox ? <label className={styles.RadioBoxItem}>
                    <input data-hj-allow ref={inputRef} className={cn(styles.Radio, cls)} name={name} onChange={onChange} onBlur={onBlur} onFocus={onFocus} type={type} checked={checked} {...value !== undefined ? {
        value
      } : {
        defaultValue
      }} />
                    {label}
                </label> : <>
                    <label className={styles.Title}>
                        {label}
                        {isRequired && <span>*</span>}
                    </label>
                    <input data-hj-allow ref={inputRef} className={cn(styles.Input, cls, {
        [styles.error]: Boolean(errors),
        [styles.success]: success,
        [styles.noMargin]: noMargin
      })} name={name} placeholder={placeholder} onChange={onChange} onBlur={onBlur} onFocus={onFocus} type={type} autoComplete="off" autoFocus={autoFocus} {...value !== undefined ? {
        value
      } : {
        defaultValue
      }} />
                    {!customError && errors && <HomePageError errors={errors} />}
                </>}
        </div>;
};
export default TypeInput;